export const isProduction = () => {
  return !window.location.host.startsWith("localhost") &&
      !window.location.host.endsWith("thymebook.com");
}

export const getBookingHost = () => {
  const host = window.location.host;
  if (host.startsWith("localhost")) {
    return "http://localhost:3001";
  } else if (host.endsWith("thymebook.com")) {
    return "https://thymebook.com";
  } else if (host.endsWith("kensu-provider-61nfs.web.app")) {
    return "https://kensu-prod.web.app/";
  }

  return "https://onkensu.com";
}

export const getProviderServer = () => {
  const host = window.location.host;
  if (host.startsWith("localhost")) {
    return "http://localhost:8082";
  } else if (host.endsWith("thymebook.com")) {
    return `https://provider-1096702705153.us-central1.run.app`
  } else if (host.endsWith("onkensu.com") || host.endsWith("kensu-provider-61nfs.web.app")) {
    return `https://provider-1086228175501.us-central1.run.app` 
  }

  throw new Error("Unknown host");
}
